
<ci-icon-button 
  class="actions-buttons__icon-button--start-route"
  type="tonal" 
  name="directions"
  [disabled]="isActionsButtonsDisabled()"
  (click)="handleStartRouteClick()"
></ci-icon-button>

<ci-icon-button 
  class="actions-buttons__icon-button--edit-route"
  type="standard" 
  name="edit"
  [disabled]="isActionsButtonsDisabled()"
  (click)="handleEditRouteClick()"
></ci-icon-button>

@if(isWaitingForResponse()){
  <ci-button
    class="actions-buttons__button--ticket"
    class-name="ci-btn-primary-s-filled"
    [arial-label]="'Comprar Billetes' | translate"
  >
    <ci-icon name="loader-debounce" scale="1x"></ci-icon>
  </ci-button>

} @else {
  <ci-button
    class="actions-buttons__button--ticket"
    class-name="ci-btn-primary-s-filled"
    [arial-label]="'Comprar Billetes' | translate"
    icon-name="gestion-contenidos-agenda-eventos"
    (click)="handleBuyTicketsClick()"
  >
    {{ getLabelTransportPayment()| translate }}
  </ci-button>
}

